module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/erasure-256a1160cb571c327eb57f8a878ea113.svg";